import {
    addToChainAfter,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadCart, PopulateApiParameter, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getCookie } from "@insite/mobius/utilities/cookies";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(
    chain,
    PopulateApiParameter,
    props => {

        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const cartMode = getCookie('cartMode');
         
        if (cartMode === 'EmergencyOrderCart' && currentPage.type !== "CartPage" && currentPage.type === "OnePageCheckoutPage") {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        }     
        props.apiParameter.forceRecalculation = false;
     
    },
);
addToChainAfter(
    chain,
    DispatchCompleteLoadCart,
    props => {

        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const cartMode = getCookie('cartMode');

        if (cartMode === 'EmergencyOrderCart' && currentPage.type !== "CartPage" && currentPage.type === "OnePageCheckoutPage") {
            if (props.apiResult.cart) {
                props.dispatch?.({
                    type: "EmergencyCart/LoadResponse",
                    cart: props.apiResult.cart,
                } as any);
            }
        }
    },
);

